import React from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";

import { ShiftInfo } from "../../hooks/useWorkSchedule";
import styles from "./ShiftFilter.module.css";

export interface ShiftFilterProps {
  /** Turno selecionado (id) ou null = "Todos os turnos". */
  value: string | null;
  onChange: (shiftId: string | null) => void;
  shifts: ShiftInfo[];
  className?: string;
}

const ALL = "__all__";

/**
 * Seletor de turno single-select ("Todos os turnos" + um turno), para ficar ao lado do filtro
 * de data nas telas de relatório. Some quando não há turno cadastrado (nada a filtrar).
 * Usa o Dropdown do design system (mesmo padrão do Paginator/filtros).
 */
const ShiftFilter: React.FC<ShiftFilterProps> = ({ value, onChange, shifts, className }) => {
  const { t } = useTranslation("general");

  if (!shifts.length) return null;

  const options = [
    { label: t("allShifts"), value: ALL },
    ...shifts.map((s) => ({ label: `${s.name} (${s.start}–${s.end})`, value: s.id })),
  ];

  return (
    <div className={`${styles.wrap} ${className ?? ""}`}>
      <span className={styles.label}>{t("shift")}</span>
      <Dropdown
        value={value ?? ALL}
        options={options}
        onChange={(e) => onChange(e.value === ALL ? null : e.value)}
        className={styles.dropdown}
        aria-label={t("shift")}
      />
    </div>
  );
};

export default ShiftFilter;
